var semver = require('semver');

module.exports = semver.satisfies(process.version, '^6.12.0 || >=8.0.0');



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsonwebtoken/lib/psSupported.js
 ** module id = 1292
 ** module chunks = 0
 **/